import { Component, Input, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from 'src/environments/environment';
import { sessionStorageKey } from '../healthpicks-operator.constants';

@Component({
  selector: 'app-healthpicks-operator',
  templateUrl: './healthpicks-operator.component.html',
  styleUrls: ['../style/global.css', './healthpicks-operator.component.css'],
})
export class HealthpicksOperatorComponent extends BaseLoginComponent implements OnInit {
  @Input() clientId: string;

  titleMaps() {
    return {
      'forgot-password': 'パスワードを忘れた方 | HealthPicks',
      'password-reset-send': 'リセット用URL送信完了 | HealthPicks',
      login: 'ログイン | HealthPicks Portal',
      register: '新規登録 | HealthPicks Portal',
      'register-resend': '',
    };
  }

  async ngOnInit() {}

  async changePassword(): Promise<void> {
    if (!this.email) {
      this.errorMessages.forgetpassword.email = 'メールアドレスを入力してください。';
      return;
    } else {
      this.errorMessages.forgetpassword.email = undefined;
    }
    const result = await super.changePassword();
    // Store email so ChangePasswordSentComponent can display it
    sessionStorage.setItem(sessionStorageKey.passwordResetEmail, this.email);
    this.navigate('password-reset-send');
    return result;
  }

  protected registrationRole(): string { return undefined; }

  get termsUrl() { return environment.apps[this.clientId]?.termUrl; }
  get privacyUrl() { return environment.apps[this.clientId]?.privacyUrl; }
}
